module.exports = __webpack_public_path__ + "img/2.c60bb70f.jpg";